<nav>
  <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2">
    <li
      [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
      *ngFor="let bread of JsonBreadcrumb; let last = last; let index = index;let first = first">
      <!-- <a [href]="index === 1 ? bread['@id'].split('/')[1] + '?search_box=' + searchName + '&refer=hotelinfo&type=1'  : ''">
        {{ bread.name }}
      </a> -->
      <ng-container *ngIf="!last">
        <a [href]="first ? '/' : bread['@id']" (click)="index == 0 ? navToPlp('/',$event) :  index === 1 ? navToPlp(bread['@id'],$event) : null">
          {{ bread.name }}
        </a>
      </ng-container>
      <ng-container *ngIf="last">
        <span class=""> {{ bread.name }}   </span>
</ng-container>

    </li>
  </ol>
</nav>
